import { getPinSize, MULTIICON_RATIO, PinIcon } from '@/constants/canvas';
import { ONE, ZERO } from '@/constants/common';
import Icon from 'ol/style/Icon';
import Style from 'ol/style/Style';
import { GetCanvasIconArgs, getCanvasIcon } from '../getCanvasIcon';
import { getCavasMultiIcon } from '../getCanvasMultiIcon';

interface Args {
  pins: GetCanvasIconArgs[];
}

export const getMultipinStyle = ({ pins }: Args): Style => {
  const pinIcon: PinIcon = 'pin';
  const icons = pins.map(({ color, value, textColor }) =>
    getCanvasIcon({
      color,
      value,
      textColor,
      pinIcon,
    }),
  );

  const img = getCavasMultiIcon(icons, pinIcon);

  const pinSize = getPinSize(pinIcon);

  return new Style({
    image: new Icon({
      displacement: [ZERO, pinSize.height * (ONE + (icons.length - ONE) * MULTIICON_RATIO)],
      anchorXUnits: 'fraction',
      anchorYUnits: 'pixels',
      img,
    }),
  });
};
